import { render } from "./form-float.vue?vue&type=template&id=15ed615b"
import script from "./form-float.vue?vue&type=script&lang=js"
export * from "./form-float.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__